import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { Select } from '@cb/apricot-react'
import styled from 'styled-components'
import { SquareButton } from '@cb/apricot-react'
import { createAPChart } from './index';
interface APChartComponentProps {
  setDistOption: Function
  distOption: string
  setStudentsOption: Function
  studentsOption: string
  apExamYear: string
  setApExamYear: Function
  apDataCurrent: any
  isInteractive: boolean
  sortType: string
  setSortType: Dispatch<SetStateAction<SortTypes>>
  apContextData: any
}

export const enum SortTypes {
  NUM_ASC = 'nStudents-asc',
  NUM_DESC = 'nStudents-desc',
  PERCENT_ASC = 'pStudents-asc',
  PERCENT_DESC = 'pStudents-desc',
  DEFAULT_ORDER = 'default-order',
}

export const APChartComponent: React.FC<APChartComponentProps> = (props) => {
  const {
    setDistOption,
    distOption,
    setStudentsOption,
    studentsOption,
    apExamYear,
    setApExamYear,
    apDataCurrent,
    isInteractive = true,
    sortType,
    setSortType,
    apContextData,
  } = props

  const [greyscaleAsc, setGreyscaleAsc] = useState(false)
  const [greyscaleDesc, setGreyscaleDesc] = useState(false)
  const apYears = [2024, 2023, 2022]

  const apYearDropDown = apYears.map((year) => ({
    label: year.toString(),
    value: year,
  }))

  useEffect(() => {
    if (apContextData) {
      createAPChart({
        apExamYear,
        distOption,
        studentsOption,
        isInteractive: true,
        apDataCurrent,
        sortType,
      })
    }
  }, [apDataCurrent, apExamYear, distOption, studentsOption, sortType])

  return (
    <>
      <div id="apChartPanel">
        <div className="row">
          <div className="col-xs-12">
            <div className={isInteractive ? 'layout-panel' : 'layout-panel-static'}>
              <div className="graph-dropdown">
                <div className="col-xs-3">
                  <Select
                    name="ap-year-dropdown"
                    data-attr="ap-year-dropdown"
                    floating={true}
                    values={apYearDropDown}
                    label="Year Applicant Took Exam"
                    defaultValue={apExamYear}
                    onChange={(selectedValue) => setApExamYear(selectedValue)}
                    condensed={true}
                  />
                </div>
                <div className="col-xs-3">
                  <Select
                    condensed={true}
                    name="scores-distribution-dropdown"
                    data-attr="scores-distribution-dropdown"
                    label="View AP Performance By"
                    floating={true}
                    values={[
                      { label: 'AP Score Distribution', value: 'dist' },
                      { label: 'AP Avg Score', value: 'avg' },
                    ]}
                    defaultValue={distOption}
                    onChange={(selectedValue) => setDistOption(selectedValue)}
                  />
                </div>
                <div className="col-xs-3">
                  <Select
                    condensed={true}
                    name="students-dropdown"
                    data-attr="students-dropdown"
                    floating={true}
                    values={[
                      { label: 'N of Students Per Cohort', value: 'nStudents' },
                      { label: '% of Students Per Cohort', value: 'pStudents' },
                    ]}
                    label="View AP Participation By"
                    defaultValue={studentsOption}
                    onChange={(selectedValue) => setStudentsOption(selectedValue)}
                  />
                </div>
              </div>
              <div className="sort-icons">
                <SquareButton
                  className="cb-margin-right-8"
                  small
                  greyscale
                  icon="order-desc"
                  disabled={greyscaleAsc}
                  onClick={() => {
                    setSortType(
                      studentsOption === 'nStudents' ? SortTypes.NUM_DESC : SortTypes.PERCENT_DESC
                    )
                    setGreyscaleAsc(true)
                    setGreyscaleDesc(false)
                  }}
                />
                <SquareButton
                  className="cb-margin-right-8"
                  small
                  greyscale
                  icon="order-asc"
                  disabled={greyscaleDesc}
                  onClick={() => {
                    setSortType(
                      studentsOption === 'nStudents' ? SortTypes.NUM_ASC : SortTypes.PERCENT_ASC
                    )
                    setGreyscaleAsc(false)
                    setGreyscaleDesc(true)
                  }}
                />
                <SquareButton
                  className="cb-margin-right-8"
                  small
                  greyscale
                  icon="refresh"
                  onClick={() => {
                    setSortType(SortTypes.DEFAULT_ORDER)
                    setGreyscaleAsc(false)
                    setGreyscaleDesc(false)
                  }}
                />
              </div>
              <div className="apChart1">
                <div className="row flex-container">
                  {(() => {
                    const result = `${distOption}-${studentsOption}-${apExamYear}-${
                      apDataCurrent ? 1 : 0
                    }`
                    return (
                      <>
                        <div id="apChart1" className="flex-item-1" data-test-ref={result}></div>
                        <div id="apChart2" className="flex-item-2" data-test-ref={result}></div>
                      </>
                    )
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
